(function () {
  'use strict';

  var FORM_ID = 'ContactForm';
  var STORAGE_KEY = 'tmj_crm_pending_lead_v1';
  var ATTRIBUTION_KEY = 'tmj_crm_attribution_v1';
  var PROXY_URL = '/apps/hotjet-crm-leads';
  var MAX_PENDING_AGE_MS = 30 * 60 * 1000;
  var ATTRIBUTION_FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'];

  function readJson(storage, key) {
    try {
      return JSON.parse(storage.getItem(key) || 'null');
    } catch (error) {
      return null;
    }
  }

  function writeJson(storage, key, value) {
    try {
      storage.setItem(key, JSON.stringify(value));
    } catch (error) {
      // Storage can be unavailable in privacy-restricted browsers.
    }
  }

  function createExternalId() {
    var bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return Array.prototype.map.call(bytes, function (value) {
      return value.toString(16).padStart(2, '0');
    }).join('');
  }

  function captureAttribution() {
    var current = readJson(window.localStorage, ATTRIBUTION_KEY) || {};
    var params = new URLSearchParams(window.location.search);
    ATTRIBUTION_FIELDS.forEach(function (field) {
      var value = params.get(field);
      if (value) current[field] = value.slice(0, 255);
    });
    current.landing_page = current.landing_page || window.location.href;
    current.captured_at = Date.now();
    writeJson(window.localStorage, ATTRIBUTION_KEY, current);
    return current;
  }

  function rememberSubmission(form) {
    var fields = new FormData(form);
    var attribution = captureAttribution();
    var pending = {
      external_id: createExternalId(),
      name: String(fields.get('contact[Name]') || ''),
      email: String(fields.get('contact[email]') || ''),
      phone: String(fields.get('contact[Phone number]') || ''),
      comment: String(fields.get('contact[Comment]') || ''),
      website: String(fields.get('contact[website]') || ''),
      page_url: attribution.landing_page || window.location.href,
      submitted_on: new Date().toISOString(),
      saved_at: Date.now()
    };
    ATTRIBUTION_FIELDS.forEach(function (field) {
      pending[field] = attribution[field] || '';
    });
    writeJson(window.sessionStorage, STORAGE_KEY, pending);
  }

  function isShopifySuccessPage() {
    return new URLSearchParams(window.location.search).get('contact_posted') === 'true';
  }

  function syncPendingLead(attempt) {
    var pending = readJson(window.sessionStorage, STORAGE_KEY);
    if (!pending) return;
    if (!pending.saved_at || Date.now() - Number(pending.saved_at) > MAX_PENDING_AGE_MS) {
      window.sessionStorage.removeItem(STORAGE_KEY);
      return;
    }

    fetch(PROXY_URL, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      credentials: 'same-origin',
      keepalive: true,
      body: JSON.stringify(pending)
    }).then(function (response) {
      return response.json().then(function (body) {
        return {ok: response.ok, body: body};
      });
    }).then(function (result) {
      if (result.ok && (result.body.status === 'created' || result.body.status === 'duplicate')) {
        window.sessionStorage.removeItem(STORAGE_KEY);
        return;
      }
      throw new Error('CRM relay rejected the lead');
    }).catch(function () {
      var delays = [1000, 5000, 15000];
      if (attempt < delays.length) {
        window.setTimeout(function () { syncPendingLead(attempt + 1); }, delays[attempt]);
      }
    });
  }

  captureAttribution();
  var form = document.getElementById(FORM_ID);
  if (form) {
    form.addEventListener('submit', function () { rememberSubmission(form); }, true);
  }
  if (isShopifySuccessPage()) {
    syncPendingLead(0);
  }
})();
